<template>
    <div>
        <PageHeader
            v-if="!hideHeader"
            class="mb-3"
            is-small
            :meta="meta">
            <template #default>
                <slot name="label">
                    {{ $t('common.index') }}
                </slot>

                <span class="badge badge-secondary">
                    {{ count }}
                </span>

                <LoadingLabel class="small text-muted" :is-loading="isLoading" />
            </template>

            <template #actions>
                <slot name="header-actions" />
            </template>
        </PageHeader>

        <slot name="alerts" />

        <div v-if="isEmpty" key="empty-list" class="card">
            <div class="card-body text-center">
                <LoadingLabel key="loading-label" :is-loading="isLoading" />
                <slot v-if="!isLoading" name="empty">
                    <em class="text-muted">
                        {{ $t('common.empty') }}
                    </em>
                </slot>
            </div>
        </div>

        <slot v-else name="collection" :items="items">
            <div key="items-list" class="card card-resources-list">
                <ul class="list-group list-group-flush m-0">
                    <li v-for="item in items" :key="item.id" class="list-group-item">
                        <div class="card-content">
                            <slot name="card" :item="item" />
                        </div>

                        <div class="card-actions">
                            <slot name="card-actions" :item="item" />
                        </div>
                    </li>
                </ul>
            </div>
        </slot>

        <div v-if="showPagination" class="flex-wrap flex-row-reverse d-sm-flex mt-3">
            <div class="text-center">
                <div class="d-inline-block">
                    <CollectionPaginator
                        :current="currentPage"
                        :last="lastPage"
                        @paginate="(page) => handlePaginate(page)" />
                </div>
            </div>

            <div class="ml-auto text-center text-muted">
                <LoadingLabel :is-loading="isLoading" />
            </div>
        </div>
    </div>
</template>

<script>
import CollectionPaginator from '@/js/components/common/controls/CollectionPaginator';
import LoadingLabel from '@/js/components/common/labels/LoadingLabel';
import PageHeader from '@/js/components/common/layout/PageHeader';

export default {
    name: 'CardsCollection',

    components: {CollectionPaginator, LoadingLabel, PageHeader},

    props: {
        items: {type: Array, required: true},
        total: {type: Number, default: null},
        currentPage: {type: Number, default: 1},
        lastPage: {type: Number, default: 1},
        hideHeader: {type: Boolean},
        isLoading: {type: Boolean},
    },

    computed: {
        isEmpty() {
            return this.items.length === 0;
        },

        count() {
            return this.total || this.items.length;
        },

        showPagination() {
            return this.currentPage > 1 || this.lastPage > 1;
        },

        meta() {
            return {
                current_page: this.currentPage,
                last_page: this.lastPage,
            };
        },
    },

    methods: {
        handlePaginate(page) {
            this.$emit('paginate', page);
        },
    },
};
</script>
